import { NgButton } from '../buttons/NgButton';
import { NgCopyButton } from '../buttons/NgCopyButton';
import {
  clickableHoverClass,
  effectivePanelBackgroundCssClass,
  effectiveSizeCssClass,
  hasText,
  shouldShowEmptyPlaceholder,
} from './dataPanelItemBase';
import type { DataPanelItemBaseProps } from './dataPanelItemBase';

export type DataPanelInlineItemProps = DataPanelItemBaseProps & {
  emptyValuePlaceholder?: string;
};

export function DataPanelInlineItem(props: DataPanelInlineItemProps) {
  const {
    title,
    value,
    allowCopyToClipboard,
    valueToCopy,
    customPanelTemplate,
    children,
    actionItems,
    showEmptyPlaceholder,
    showEmptyPlaceholderWhen,
    linkUrl,
    editable,
    onEditClick,
    clickable,
    onPanelClick,
    hoverTooltip,
    testID,
    emptyValuePlaceholder = '–',
  } = props;

  if (customPanelTemplate != null) {
    return (
      <div
        className={`data-panel-inline-item p-2 ${effectiveSizeCssClass(props)} ${clickableHoverClass(props)}`}
        title={hoverTooltip}
        data-testid={testID}
      >
        {customPanelTemplate}
      </div>
    );
  }

  const effectiveValueToCopy = valueToCopy ?? value;
  const showCopy = allowCopyToClipboard === true && hasText(effectiveValueToCopy);
  const effectiveShowEmptyPlaceholder = shouldShowEmptyPlaceholder(
    value,
    showEmptyPlaceholder,
    showEmptyPlaceholderWhen,
  );

  const panelItemClicked = async () => {
    if (clickable && onPanelClick) {
      await onPanelClick();
    }
  };

  return (
    <div
      className={`data-panel-inline-item ${effectiveSizeCssClass(props)} ${clickableHoverClass(props)}`}
      style={{ paddingBlock: '2px' }}
      onClick={() => void panelItemClicked()}
      title={hoverTooltip}
      data-testid={testID}
    >
      <div className={`panel-data-item__color px-1 rounded-2 ${effectivePanelBackgroundCssClass(props)}`}>
        <div className="data-item d-flex justify-content-between align-items-stretch gap-1">
          {title != null && (
            <div
              className="small text-muted text-lowercase align-self-center py-1"
              style={{ lineHeight: '21px' }}
            >
              {title}
            </div>
          )}

          <div
            className="d-flex flex-grow-1 align-items-stretch justify-content-between"
            style={{ gap: '0.125rem' }}
          >
            <div className="d-flex flex-grow-1 align-items-center justify-content-end py-1 medium text-end">
              {effectiveShowEmptyPlaceholder ? (
                emptyValuePlaceholder
              ) : linkUrl != null ? (
                <a href={linkUrl}>{value}</a>
              ) : (
                value
              )}

              {children}
            </div>

            {actionItems}

            {showCopy && (
              <NgCopyButton
                valueToCopy={effectiveValueToCopy}
                cssClass="data-panel-inline-item__icon-button"
              />
            )}

            {editable && (
              <NgButton
                icon="fal fa-edit"
                type="link"
                size="small"
                onClick={onEditClick}
                cssClass="data-panel-inline-item__icon-button"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
